import type { MediaAsset, Project } from '../types/content';
import { formatCurrency } from './format';

export function projectValue(project: Project) {
  return project.valueLabel || (project.value === undefined ? 'Dado a confirmar' : formatCurrency(project.value));
}

export function publicComposition(projects: Project[]) {
  const entries = projects.filter((project) => project.fundingType === 'publico');
  // Sum cents; private and mixed counterpart amounts need separate documentation.
  const cents = entries.reduce((sum, project) => sum + Math.round((project.value ?? 0) * 100), 0);
  return { entries, subtotal: cents / 100 };
}

export function safeSourceUrl(value?: string) {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined;
  } catch { return undefined; }
}

export function disclosureLabel(media: MediaAsset) {
  return media.aiDisclosure === 'synthetic_content'
    ? media.aiDisclosureLabel || 'Imagem produzida/manipulada com inteligência artificial.'
    : undefined;
}

export function areaValue(projects: Project[], area: Project['area']) {
  const entries = projects.filter((project) => project.area === area);
  const value = entries.reduce((sum, project) => sum + Math.round((project.value ?? 0) * 100), 0) / 100;
  const label = area === 'investimento-privado' ? 'Investimento privado'
    : entries.some((project) => project.fundingType === 'contrapartida')
      ? 'Recursos públicos e contrapartida' : 'Recursos públicos';
  return { value, label };
}

export function areaQuantity(projects: Project[], area: Project['area'], key: keyof NonNullable<Project['quantities']>) {
  return projects.filter((project) => project.area === area).reduce((sum, project) => sum + (project.quantities?.[key] ?? 0), 0).toLocaleString('pt-BR');
}
